(ns manatee.edit.subs
  (:require [manatee.edit.app-db :as db]
            [re-frame.core :as rf]))

;; Edits by id
(rf/reg-sub
 ::edits
 (fn edits
   [db _]
   (db/get-edits db)))

;; Edits by ident
(rf/reg-sub
 ::edits-by-idents
 (fn edits-by-idents
   [db _]
   (db/get-edits-by-ident db
                          (db/selected-tab db))))

(rf/reg-sub
 ::edit-ident
 :<- [:kee-frame/route]
 (fn edit-ident
   [{{:keys [item-id user-id]} :route-params} _]
   (and (string? item-id)
        (string? user-id)
        [user-id item-id])))

(rf/reg-sub
 ::edit-by-ident
 :<- [::edits-by-idents]
 :<- [::edit-ident]
 (fn edit-by-ident
   [[edits edit-ident] _]
   (or (get edits edit-ident)
       {:loading? true})))

;; table
(rf/reg-sub
 ::table
 (fn table
   [db [_ table]]
   (get-in db [:table (db/selected-tab db) table])))

(rf/reg-sub
 ::table-component-loading
 (fn table-component-loading
   [db _]
   (db/get-table-component-loading db)))

(rf/reg-sub
 ::edits-table
 :<- [::edits-by-idents]
 :<- [::table :edits]
 (fn edits-table
   [[edits {:keys [edit-idents total]}]]
   (let [edits* (map (fn [ident]
                       (get edits ident))
                     edit-idents)]
     {:edits edits*
      :total total})))

(rf/reg-sub
 ::edits-table-params
 (fn edits-table-params
   [db _]
   (db/table-params db)))

(rf/reg-sub
 ::selected-tab
 (fn selected-tab
   [db _]
   (db/selected-tab db)))

(rf/reg-sub
 ::compare-options
 (fn compare-options
   [db _]
   (db/compare-options db)))
